import React, { useState, useEffect } from 'react';
import { Modal, Button, TableToolbar, TableToolbarContent, TableToolbarSearch } from 'carbon-components-react';
import { Carousel } from "react-bootstrap";
import { ArrowRight32 } from '@carbon/icons-react';
import i18n from "../../../i18n";
import DataTableComponent from 'common/DataTableComponent';
require("./_insights.scss");

const Insights = (props) => {

    const [showInsightTable, setShowInsightTable] = useState(false);
    const [searchedInsightData, setSearchedInsightData] = useState([]);
    const [insightCarousalRows, setCarousalRows] = useState(props.insightCarousalRows ? props.insightCarousalRows : []);
    const [insightTableRows, setInsightTableRows] = useState(props.insightTableRows ? props.insightTableRows : []);
    const [CarouselIndex, setCarouselIndex] = useState(props.CarouselIndex ? props.CarouselIndex : 0);
    const [searchedInsightValue, setSearchedInsightValue] = useState('');

    useEffect(() => {
        setCarousalRows(props.insightCarousalRows);
        setCarouselIndex(0);
    }, [props.insightCarousalRows]);

    useEffect(() => {
        setInsightTableRows(props.insightTableRows);
    }, [props.insightTableRows]);

    useEffect(() => {
        setCarouselIndex(props.CarouselIndex)
    }, [props.CarouselIndex]);

    const SeeAll = i18n.t('manageAutomation.SeeAll');
    const InsightDetail = i18n.t('manageAutomation.InsightDetail');
    const Title = i18n.t('manageAutomation.Title');
    const ApplicationName = i18n.t('manageAutomation.ApplicationName');
    const Date = i18n.t('manageAutomation.Date');
    const ClientName = i18n.t('manageAutomation.ClientName');
    const Details = i18n.t('manageAutomation.Details');
    const InsightsText = i18n.t('manageAutomation.Insights');
    const NoInsightsAvailable = i18n.t('manageAutomation.NoInsightsAvailable');
    const Items = i18n.t('manageAutomation.Items');

    const openInsightTable = () => {
        setShowInsightTable(true);
    }
    const toggleInsightTable = () => {
        setShowInsightTable(false);
        props.toggleInsightModal();
    }
    const onRowExpand = (row) => {
        let data = {
            documentId: row.cells[5].value,
            isAcknowledged: false
        }
        props.getAcknowledgeData(data);
    }
    const searchTable = (event) => {
        let searchString = event.target.value.toUpperCase();
        let newList = [];
        let string, pattern;
        let matchedStrings;
        if (searchString) {
            newList = insightTableRows.filter((element) => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        if (element[property] && property !== "id" && property !== "details") {
                            string = element[property];
                        }
                        else string = '';
                        string = string ? string.toString() : "";
                        pattern = new RegExp("(\\w*" + searchString + "\\w*)", "gi");
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            newList = newList.concat([element]);
                            return newList;
                        }
                    }
                }
            });
            setSearchedInsightData(newList);

        } else {
            setSearchedInsightData([]);
        }
    };

    return (
        <>
            <Modal
                className='insight-modal'
                passiveModal
                open={props.showInsightModal}
                onRequestClose={() => { props.toggleInsightModal(); }}
                size="xs"
                modalHeading={InsightDetail}>
                <div>
                    {!showInsightTable &&
                        <div>
                            {
                                insightCarousalRows.length > 0 ?
                                    <Carousel variant="dark" activeIndex={CarouselIndex} direction={"right"} onSelect={props.handleCarouselSelect} defaultActiveIndex={0} interval={null}>
                                        {insightCarousalRows.map((item, index) => {
                                            return <Carousel.Item key={item.documentId}>
                                                <section>
                                                    <div className='title'>{Title}:</div>
                                                    <div className='value'>{item.error_title}</div>
                                                </section>
                                                <section>
                                                    <div className='title'>{ApplicationName}:</div>
                                                    <div className='value'>{item.name}</div>
                                                    {/* <div className='value'>{item.name} {item.documentId}</div> */}
                                                </section>
                                                <section>
                                                    <div className='title'>{ClientName}:</div>
                                                    <div className='value'>{item.client}</div>
                                                </section>
                                                <section>
                                                    <div className='title'>{Date}:</div>
                                                    <div className='value'>{item.date}</div>
                                                </section>
                                                <section className='details-section'>
                                                    <div className='title'>{Details}:</div>
                                                    {item.details.map((error) => {
                                                        return <div className='value'>{error}</div>
                                                    })}
                                                </section>
                                            </Carousel.Item>
                                        })}
                                    </Carousel>
                                    : <div className='no-data'>{NoInsightsAvailable}</div>
                            }
                            <Button kind='ghost' iconDescription={SeeAll} onClick={openInsightTable} renderIcon={ArrowRight32} className="see-all-button">{SeeAll}</Button>
                        </div>
                    }
                </div>
            </Modal>
            <Modal
                className='insight-modal insights-table'
                passiveModal
                open={showInsightTable}
                onRequestClose={() => { toggleInsightTable() }}
                size="xs"
                modalHeading={InsightsText} >
                <div>
                    <TableToolbar aria-label="data table toolbar">
                        <TableToolbarContent>
                            <TableToolbarSearch onChange={(e) => { setSearchedInsightValue(e.target.value); searchTable(e); }}
                                className="search-button" size='sm' expanded={true} />
                        </TableToolbarContent>
                    </TableToolbar>
                    <DataTableComponent isExpandable={true} size="md" loading={props.insightsDataLoading} tablePaginationLimit={7} defaultCurrentPageSize={7}
                        expandedTableTitle={Details} rows={searchedInsightValue.length ? searchedInsightData : insightTableRows}
                        headers={props.insightsTableHeaders} itemsPerPageText={Items} showPagination={true} onRowExpand={onRowExpand}
                    />
                </div>
            </Modal>
        </>
    )
};

export default Insights;
